import mapboxgl from 'mapbox-gl';

class locationsMap {
    constructor( element = null, data = null ) {
        if ( element === null || data === null || ! ( typeof data === 'array' || typeof data === 'object' ) ) {
            // remove map here
            throw('A valid data object is required to initialize the events map');
        }

        mapboxgl.accessToken = 'pk.eyJ1Ijoiam1vbGxtYW4iLCJhIjoiY2tlZDNqeHNpMGQ2bTM1azlxdzVldDBsbSJ9.PEw2Y2WPJrUQzD2aqo9S2Q';

        this.elementRef = element;
        this.map = null;
        this.mapItems = data;
        this.searchableItems = [];
        this.config = {
            mapElement: document.getElementById(this.elementRef.dataset.mapElement),
            mapStyleUrl: 'mapbox://styles/jmollman/ckecxi22k024518oelpn1egql',
            disableScrollZoom: true,
        };

        this.initMapbox();

        // this.appendMapItemMarkup();
        
    }

    initMapbox() {
        this.map = new mapboxgl.Map({
            container: this.config.mapElement,
            style: this.config.mapStyleUrl,
            center: [0,10], // Center of the World, then up a bit - NOTE: google geo codes as LATLNG, mapbox expects LNGLAT
            zoom: 2
        });

        // Additional map configuration here
        if (this.config.disableScrollZoom) {
            this.map.scrollZoom.disable();
            this.map.addControl(new mapboxgl.NavigationControl());
        }

        this.plotMapItemMarkers();

        this.fitMapToMarkerBounds();
    }

    appendMapItemMarkup() {
        // console.log('Append Map Item Markup');
    }

    fitMapToMarkerBounds() {
        const bounds = [], buffer = 20;

        // this math is WRONG but it kinda does the job...
        bounds.push(this.mapItems.reduce((t,c) => {
            return [Math.min(c.coordinates.lng, t[0]), Math.min(c.coordinates.lat, t[1])];
        }, [10e6,10e6]).map((el) => el -= buffer));

        bounds.push(this.mapItems.reduce((t,c) => {
            return [Math.max(c.coordinates.lng, t[0]), Math.max(c.coordinates.lat, t[1])];
        }, [-10e6,-10e6]).map((el) => el += buffer));

        this.map.fitBounds(bounds);
    }

    plotMapItemMarkers() {
        this.mapItems.forEach((item, index) => {
            const markerElement = document.createElement('div');
            markerElement.className = 'map-marker';
            markerElement.dataset.index = index;

            markerElement.addEventListener('click', function(e) {
                Array.from(document.querySelectorAll('.map-marker')).forEach((marker) => marker.classList.remove('active'));
                this.classList.add('active');
            });

            const popupHTML = this.getPopupHTML(item);

            new mapboxgl.Marker(markerElement)
                .setLngLat([item.coordinates.lng, item.coordinates.lat])
                .setPopup(
                    new mapboxgl.Popup({ offset: 25 }).setHTML(popupHTML).on('open', function(e){ this._closeButton.innerHTML = ''; })
                ).addTo(this.map);
        });
    }

    removeOpenPopups() {
        Array.from(document.querySelectorAll('.map-popup-solo')).forEach((popup) => {
            popup.remove();
        });
    }

    getPopupHTML(item) {
        let html = `<div class="map-popup-wrapper">`;
        html += item.title ? `<p class="map-popup-title">${item.title}</p>` : ``;
        html += item.type ? `<p class="map-popup-type">${item.type}</p>` : ``;
        html += item.address ? `<p class="map-popup-address">${item.address}</p>` : ``;
        html += item.phone ? `<p class="map-popup-phone">${item.phone}</p>` : ``;
        html += item.url ? `<!--<a href="${item.url}" class="btn btn-outline-dark btn-block btn-sm">View Details</a>-->` : ``;
        html += `</div>`;
        return html;
    }
}
window.locationsMap = locationsMap;